<template>
    <nav>
        <ul class="pagination justify-content-end">
            <li :class="['page-item', {disabled: currPage === 1}]"
                @click="currPage === 0 ? goToPage(currPage) : goToPage(currPage - 1)">
                <a class="page-link"
                   name="previous">
                    {{$t('UI.previous')}}
                </a>
            </li>
            <li class="page-item out-of-bound"
                @click="goToPage(1)"
                v-if="(currPage > 3)">
                <a class="page-link" name="first">1</a>
            </li>
            <li :class="['page-item', {active: number === currPage}]"
                v-for="number in pagesLength"
                @click="goToPage(number)">
                <a class="page-link" name="page x"
                   v-if="(number >= currPage - 2 && number <= currPage + 2)">
                    {{number}}
                </a>
            </li>
            <li class="page-item out-of-bound"
                v-if="currPage + 2 < pagesLength"
                @click="goToPage(pagesLength)">
                <a class="page-link" name="last">
                    {{pagesLength}}
                </a>
            </li>
            <li :class="['page-item', {disabled: currPage >= pagesLength }]"
                @click="currPage < pagesLength ? goToPage(currPage + 1) : goToPage(currPage)">
                <a class="page-link" name="next">
                    {{$t('UI.next')}}
                </a>
            </li>
        </ul>
    </nav>
</template>

<script type="text/babel">

export default {
    props: {
        currPage: {
            type: Number,
            required: true
        },
        pagesLength: {
            type: Number,
            required: true
        }
    },
    watch: {
        pagesLength (newVal) {
            if((this.currPage > newVal) && this.currPage > 1) {
                this.goToPage(this.currPage - 1);
            }
        }
    },
    methods: {
        /**
         * @function goToPage
         * @param {Number} page - page number
         * @description emits an event passed to parent component and updates the currPage property in parent component
         * */
        goToPage (page) {
            this.$emit('update:currPage', page);
        }
    }
};

</script>

<style lang="scss" scoped>
    .page-item {
        .page-link {
            cursor: pointer;
        }
        &.active {
            .page-link {
                @include color('background-color', sidebar-bg);
                @include color('border-color', sidebar-bg);
            }
        }
        &.out-of-bound {
            .page-link {
                @include color('background-color', darker-secondary);
                @include color('border-color', darker-secondary);
            }
        }
    }
    
    .page-link.disabled {
        cursor: not-allowed;
    }
</style>
